import React from "react";
import { FaRobot, FaCode, FaLightbulb, FaLaptopCode } from "react-icons/fa";
import "./homeschool.css";

const Homeschool = () => {
  return (
    <section className="stx-homeschool">

      {/* HERO SECTION */}
      <div className="stx-homeschool__hero">
        <div className="stx-homeschool__content">
          <h1>Robotics & Coding for Homeschoolers</h1>

          <p className="stx-homeschool__subtitle">
            Future-ready STEM learning designed for home-based learners.
            Students build real-world skills through robotics, coding, and hands-on projects.
          </p>

          <p className="stx-homeschool__description">
            At STEMTRIX, we bring structured, engaging, and practical tech education
            to homeschool students. Learners design, build, and program real
            projects while developing creativity, confidence, and problem-solving skills.
          </p>

          <div className="stx-homeschool__cta">
            <a
              href="https://wa.me/254728128353?text=Hello!%20I%20want%20to%20enroll%20my%20child%20in%20the%20homeschool%20robotics%20program."
              target="_blank"
              rel="noopener noreferrer"
              className="stx-btn"
            >
              Enroll Now
            </a>

            <a href="/contact" className="stx-btn stx-btn--outline">
              Learn More
            </a>
          </div>
        </div>
      </div>

      {/* FEATURES SECTION */}
      <div className="stx-homeschool__features">
        <h2>What Your Child Will Learn</h2>

        <div className="stx-homeschool__grid">
          <div className="stx-feature">
            <FaCode />
            <h3>Coding Fundamentals</h3>
            <p>Learn Python and logical thinking through fun, structured lessons.</p>
          </div>

          <div className="stx-feature">
            <FaRobot />
            <h3>Robotics & Engineering</h3>
            <p>Build real robots and understand how machines work in the real world.</p>
          </div>

          <div className="stx-feature">
            <FaLightbulb />
            <h3>Problem Solving</h3>
            <p>Develop critical thinking through challenges and innovation tasks.</p>
          </div>

          <div className="stx-feature">
            <FaLaptopCode />
            <h3>Creative Projects</h3>
            <p>Turn ideas into real working prototypes and digital solutions.</p>
          </div>
        </div>
      </div>

    </section>
  );
};

export default Homeschool;